import { render, staticRenderFns } from "./CustomerCenter.vue?vue&type=template&id=4eaa4456"
import script from "./CustomerCenter.vue?vue&type=script&lang=js"
export * from "./CustomerCenter.vue?vue&type=script&lang=js"
import style0 from "./CustomerCenter.vue?vue&type=style&index=0&id=4eaa4456&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports